const MuiFormControl = {
    defaultProps: {
        variant: 'outlined',
        size: 'small'
    }
};
export { MuiFormControl };

//# sourceMappingURL=form-control.js.map